import { fetchWrapper } from "../Helpers/fetch-wrapper";
import { toApiPage } from "./queryParams";

const getProjects = async (swp_org_id) => {
  const data = await fetchWrapper.get(`${process.env.REACT_APP_API_ENDPOINT}/project?filters[swp_org_id]=${swp_org_id}`);
  return data.data || [];
};

const getAllProjects = async (page, pageSize, sortBy, sortOrder, filters = {}) => {
  const params = [];
  if (page || page === 0) params.push(`page=${toApiPage(page)}`);
  if (pageSize) params.push(`pageSize=${pageSize}`);
  if (sortBy) params.push(`sortBy=${sortBy}`);
  if (sortOrder) params.push(`sortOrder=${sortOrder}`);
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params.push(`filters[${key}]=${encodeURIComponent(value)}`);
  });
  return fetchWrapper.get(`${process.env.REACT_APP_API_ENDPOINT}/project?${params.join("&")}`);
};

export const Projects = { getProjects, getAllProjects };
